import Footer from "./styled";

export default Footer;